export const cognitoConfig = {
  region: process.env.REACT_APP_REGION as string,
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID as string,
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID as string,
  cognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN as string,
  hostedUiDomain: process.env.REACT_APP_COGNITO_HOSTED_UI_DOMAIN as string,
  cloudfrontDomain: process.env.REACT_APP_CLOUDFRONT_DOMAIN as string
};

// Add type safety
export type CognitoConfigType = {
  region: string;
  userPoolId: string;
  clientId: string;
  cognitoDomain: string;
  hostedUiDomain: string;
  cloudfrontDomain: string;
};

// Type assertion to ensure cognitoConfig matches CognitoConfigType
const configuredConfig = cognitoConfig as CognitoConfigType;

// Runtime check for all required properties
Object.entries(configuredConfig).forEach(([key, value]) => {
  if (!value) {
    throw new Error(`Missing required configuration: ${key}`);
  }
});

export default configuredConfig;